import {logos} from "../logos"
export default function slogo({name,className=''}) {
    return (
        <>
            {logos[name]}
        </>        
    )
}